export default {
  costLines: [],
  costLine: undefined,
};
